/* Allows only HTTPS URLs from these domains:
  - domgen-usa.com
  - domgenusa-test.cloud
  - domesticandgeneral.us
  - domgencloud.net

 Examples urls that are allowed:
  - https://api.aws.<env>.test.domgenusa-test.cloud
  - https://api.aws.preprod.domgen-usa.com
  - https://api.aws.domgen-usa.com
  - https://api.catalogue.use1.<env>.test.domgenusa-test.cloud
  - https://api.catalogue.svc.domesticandgeneral.us
  - https://api.global-reg.e2e-domgendotcom-<env>.aws.domgencloud.net

 Not allowed:
  - http://domgen-usa.com (not HTTPS)
  - https://example.com   (not in whitelist)  
*/

export const TRACE_HEADER_WHITELIST_REGEX =
  /^https:\/\/(?:[^/]+\.)?(domgen-usa\.com|domgenusa-test\.cloud|domesticandgeneral\.us|domgencloud\.net).*$/;
